import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CopyButton, Spinner, Tooltip } from '../../../components/shared';
import { VerificationStatus } from '../../../types';
import { BadgeCheckIcon, WarningCircleIcon } from '../../../components/shared/icons';
import { INTEGRATION_FINALIZED } from '../../../hooks';
import { fonts } from '../../../styles/fonts';

interface Props {
  proxyAddress?: string;
  verificationStatus: VerificationStatus;
}

export const VerifiedProxyAddress = ({ proxyAddress, verificationStatus }: Props) => {
  if (verificationStatus === 'verifying') {
    return (
      <Container>
        <Spinner />
        <div className="verifying">Verifying...</div>
      </Container>
    );
  }

  if (!proxyAddress) {
    return (
      <Container>
        <div className="proxy-address">—</div>
        <CopyButton copyString="" disabled />
      </Container>
    );
  }

  return (
    <Container>
      {verificationStatus === 'verified' ? (
        <Tooltip content="The address has been verified and confirmed to contain a deployed contract.">
          <Tooltip.Trigger>
            <BadgeCheckIcon className="verification-icon" />
            <span className="sr-only">Verified</span>
          </Tooltip.Trigger>
        </Tooltip>
      ) : (
        <WarningCircleIcon className="verification-icon" />
      )}
      <div className="proxy-address">{proxyAddress}</div>
      <CopyButton copyString={proxyAddress} onClick={() => localStorage.setItem(INTEGRATION_FINALIZED, 'true')} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 4px;

  &:has(.verifying) {
    gap: 4px;

    svg {
      width: 16px;
      height: 16px;
    }

    .verifying {
      ${fonts.body[15]};
      color: var(--color-base-light);
    }
  }

  .verification-icon {
    width: 15px;
    min-width: 15px;
    height: 15px;
  }

  .proxy-address {
    word-break: break-word;
    ${fonts.body[14]};
  }

  .copy-btn {
    margin-left: -8px;
    padding-right: 0;

    svg {
      width: 16px;
      height: 16px;
      padding: 0;
    }
  }

  @media (min-width: 460px) {
    .proxy-address {
      ${fonts.body[11]};
    }
  }

  @media (min-width: ${breakpoints.sm}px) {
    &:has(.verifying) {
      svg {
        width: 24px;
        height: 24px;
      }

      .verifying {
        ${fonts.body[12]};
      }
    }

    .proxy-address {
      ${fonts.subtitle[8]};
    }

    .verification-icon {
      width: 24px;
      height: 24px;
    }

    .copy-btn {
      margin-left: -6px;

      svg {
        width: 18px;
        height: 18px;
      }
    }
  }
`;
